module.exports = __webpack_public_path__ + "static/media/15UN-Habitat12.52396b98.jpg";